
import {System} from './System'

export const Operator = {

    getBootstrapColumns() {

        const columns = [
            { field: 'key',   headerName: 'Key',          type: 'string',  width: 180,  sortable: true },
            { field: 'value', headerName: 'Value',        type: 'string',  width: 240, sortable: true},
            { field: 'desc',  headerName: 'Beschreibung', type: 'string',  width: 300, sortable: true }
        ]
        columns.push(...System.getSystemColumns());

        return columns;
    }

};

